<template>
  <div>
    <div class="page page__list" v-if="!isVC">
      <search-bar
        @search="onSearch"
        name="ve_code,ve_name"
        placeholder="输入供应商编号、名称进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/document/vendor/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.ve_name}}</p>
            <p class="list-item-muted">{{item.ve_type}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.ve_code}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.ve_audit_status=='已审核'}"
            >{{item.ve_audit_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">共：{{items.length}}个</label>
      </div>
      <add-button to="/document/vendor_edit" />
    </div>
    <div class="page page__list" v-if="isVC">
      <search-bar
        @search="onSearch"
        name="vc_code,vc_vename_old,vc_vename_new"
        placeholder="输入单号、新旧企业名称进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/document/vendor_change/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.vc_vename_new}}</p>
            <p class="list-item-muted">{{item.vc_vename_old}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.vc_code}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.vc_status=='已审核'}"
            >{{item.vc_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">共：{{items.length}}个</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isVC: false,
      listUrl: "/api/document/vendor/list",
      filters: [
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "ve_audit_status_code!='AUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "ve_audit_status_code='AUDITED'"
            },
            {
              value: 3,
              label: "待变更",
              condition: "vc_statuscode='SUBMITTED'"
            },
            {
              value: 4,
              label: "已变更",
              condition: "vc_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isChange = filter.value > 2
      this.listUrl = isChange ? '/api/vendor/change/list' : '/api/document/vendor/list'
      // this.filters[0].name = isChange ? 'fixedassetschange.createTime' : 'fa_date'
      this.isVC = isChange ? true : false
      filterBar.initConfig()
      next()
    },
  }
};
</script>